export const setItemLocalStorage = function (key: string, value: string | object | number) {
	window.localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
};

export const getItemLocalStorage = function (key: string): any {
    const item = window.localStorage[key];
    return item ? JSON.parse(item) : null;
};

export const removeItemLocalStorage = function (key: string) {
	return window.localStorage.removeItem(key);
};

